
$(function () {
    $('#activmap-wrapper').activmap({
        places: [],
        icon: 'https://cdn.shopify.com/s/files/1/0035/5991/5629/files/Vector_1.png?v=1729801983',
        posPanel: 'left',
        country: 'mx',
        mapType: 'roadmap',
        request: 'large',
        locationTypes: ['geocode', 'establishment'],
    });
});